import Model from "../../Model";
//import { actions } from '@/store';

class retailOrders extends Model{

    buildUrl ({ param }) {
        return ['retail/orders', param];
    }
}


export default new retailOrders;